import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import CONSTANTS from '../CONSTANTS.json';

const TaskDropdownModal = ({
    isOpen,
    onClose,
    item,
    handleEditTitle,
    setShowBox,
    removeTask,
    clearHighlight,
    handleClick,
    setHoverIndex,
    setColorIndexID,
    handleTaskSelectedColor,
    activePatch,
    indexId,
    selectedBoardId,
    taskDeadlineDates,
    handleUpdateTask,
    position,
}) => {
    const navigate = useNavigate();

    const actions = [
        // 'To-Do',
        'View Details',
        'Edit title',
        // 'Delete',
        'Highlight',
    ];
    const handleActionClick = (action) => {
        switch (action) {
            case 'To-Do':
                handleUpdateTask('To-Do', 'status', item);
                break;
            case 'Edit title':
                handleEditTitle(item);
                break;
            case 'Delete':
                setShowBox(true);
                break;
            case 'View Details':
                navigate(`/detail/${item.id}`, {
                    state: {
                        selectedMail: item,
                        deadlineDate: taskDeadlineDates,
                        taskID: item.id,
                        clickMailTask: true,
                        type: 'Gmail',
                        openTaskDataSidebar: true,
                        currentTask: item,
                        boardId: selectedBoardId,
                    },
                });
                break;
            default:
                break;
        }
    };

    if (!isOpen) return null;

    const modalContent = (
        <div className="fixed inset-0 z-40" onClick={onClose}>
            <div
                className="dropdown dropdown-tactic drop-color open"
                style={{
                    position: 'absolute',
                    top: `${position?.top || 0}px`,
                    left: `${position?.left || 0}px`,
                    zIndex: 50,
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="grid-ui">
                    <div className="grid-list-chid">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="#7d7d7d"
                                className="bi bi-box-arrow-up-right inlineBlock"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                                />
                                <path
                                    fillRule="evenodd"
                                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 0 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                                />
                            </svg>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="#7d7d7d"
                                className="bi bi-pencil-fill inlineBlock"
                                viewBox="0 0 16 16"
                            >
                                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                            </svg>
                        </div>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="currentColor"
                                class="bi bi-droplet-fill inlineBlock"
                                viewBox="0 0 16 16"
                            >
                                <path d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c-.75.002-2.254 1.676-3.568 3.638C3.122 5.096 2 6.345 2 10a6 6 0 0 0 6 6" />
                            </svg>
                        </div>
                    </div>
                    <div className="ulname-list grid-child-one">
                        {actions.map((action) => (
                            <div key={action}>
                                <a
                                    id={action}
                                    className="text-listdrop"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleActionClick(action);
                                    }}
                                    data-no-popup
                                >
                                    {action === 'Highlight' && (
                                        <div
                                            className="highlight-container"
                                            style={{
                                                display: 'inline-block',
                                                position: 'absolute',
                                                right: '7px',
                                            }}
                                        >
                                            <span
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearHighlight();
                                                    onClose();
                                                }}
                                                className="clear-button clr-position clear-on"
                                            >
                                                Clear
                                            </span>
                                        </div>
                                    )}
                                    {action.charAt(0).toUpperCase() + action.slice(1)}
                                </a>
                            </div>
                        ))}
                    </div>
                    <div className="Grid-Circle">
                        {CONSTANTS?.color?.map((color, index) => (
                            <div
                                key={index}
                                className={`patch ${color.color} ${activePatch === color.color ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleClick(color.value);
                                    setHoverIndex(color.value1);
                                    setColorIndexID(indexId);
                                    handleTaskSelectedColor(item.id, color.value);
                                    onClose();
                                }}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

TaskDropdownModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    handleEditTitle: PropTypes.func.isRequired,
    setShowBox: PropTypes.func.isRequired,
    removeTask: PropTypes.func.isRequired,
    clearHighlight: PropTypes.func.isRequired,
    handleClick: PropTypes.func.isRequired,
    setHoverIndex: PropTypes.func.isRequired,
    setColorIndexID: PropTypes.func.isRequired,
    handleTaskSelectedColor: PropTypes.func.isRequired,
    activePatch: PropTypes.string,
    indexId: PropTypes.number,
    position: PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number,
    }),
};

TaskDropdownModal.defaultProps = {
    position: { top: 0, left: 0 },
};

export default TaskDropdownModal;
